import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import StructuredData from '../../components/feature/StructuredData';

const HomePage = () => {
  useEffect(() => {
    document.title = 'Vaciado de Locales Barcelona | ECOSERVEIS - Servicio Rápido 24-48h';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Vaciado profesional de locales comerciales, naves y oficinas en Barcelona. Retirada de mobiliario, gestión de residuos y limpieza. Presupuesto sin compromiso. ☎ 644 613 451');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Vaciado profesional de locales comerciales, naves y oficinas en Barcelona. Retirada de mobiliario, gestión de residuos y limpieza. Presupuesto sin compromiso. ☎ 644 613 451';
      document.head.appendChild(meta);
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'vaciado de locales Barcelona, vaciado de naves industriales Barcelona, vaciado de oficinas, retirada de mobiliario comercial, desmontaje de estanterías');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'vaciado de locales Barcelona, vaciado de naves industriales Barcelona, vaciado de oficinas, retirada de mobiliario comercial, desmontaje de estanterías';
      document.head.appendChild(meta);
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Vaciado de Locales Barcelona | ECOSERVEIS - Servicio Rápido 24-48h');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Vaciado de Locales Barcelona | ECOSERVEIS - Servicio Rápido 24-48h';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Vaciado profesional de locales comerciales, naves y oficinas en Barcelona. Retirada de mobiliario, gestión de residuos y limpieza. Presupuesto sin compromiso.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Vaciado profesional de locales comerciales, naves y oficinas en Barcelona. Retirada de mobiliario, gestión de residuos y limpieza. Presupuesto sin compromiso.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://www.vaciarlocales.net/');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://www.vaciarlocales.net/';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <>
      <StructuredData type="home" />
      <Header />
      <WhatsAppButton />
      
      <main>
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/9c021fd8c3b496a162c92859120987f7.jpg"
              alt="Espacio comercial en Barcelona"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-white/95 via-white/90 to-white/85"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Left Content */}
              <div className="text-left">
                <div className="inline-flex items-center px-4 py-2 bg-[#FF6B35]/10 rounded-full mb-6">
                  <div className="w-2 h-2 bg-[#FF6B35] rounded-full mr-2 animate-pulse"></div>
                  <span className="text-sm font-semibold text-[#FF6B35]">Servicio Profesional en Barcelona</span>
                </div>
                
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
                  Vaciado de locales en Barcelona
                </h1>
                
                <p className="text-xl md:text-2xl text-gray-700 mb-8 leading-relaxed">
                  Servicio profesional de <strong>vaciado de locales comerciales</strong>, naves industriales y oficinas. Rápido, eficiente y con gestión de residuos incluida.
                </p>

                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+34644613451"
                    className="inline-flex items-center justify-center px-8 py-4 bg-[#FF6B35] text-white text-lg font-semibold rounded-lg hover:bg-[#E55A2B] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                  >
                    <div className="w-5 h-5 flex items-center justify-center mr-2">
                      <i className="ri-phone-fill"></i>
                    </div>
                    Llamar Ahora +34 644 613 451
                  </a>
                </div>
              </div>
              
              {/* Right Content */}
              <div className="relative">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=workers%20clearing%20store%20Barcelona&width=600&height=700&seq=hero-home-001&orientation=portrait"
                    alt="Equipo profesional vaciando local comercial en Barcelona"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Servicios Destacados */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 mb-16">
              <div>
                <h2 className="font-['Sora'] text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                  Servicios completos<br />de vaciado
                </h2>
              </div>
              <div className="flex items-end">
                <p className="text-lg text-gray-600 leading-relaxed max-w-md">
                  Especializados en <Link to="/servicios" className="text-[#FF6B35] hover:underline font-semibold">vaciado de locales Barcelona, naves industriales y oficinas</Link>. Gestión integral con <Link to="/servicios" className="text-[#FF6B35] hover:underline">retirada de mobiliario comercial y desmontaje de estanterías</Link>.
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {/* Card 1 */}
              <Link to="/servicios" className="bg-white rounded-xl p-8 hover:-translate-y-2 transition-all duration-300 shadow-md hover:shadow-2xl cursor-pointer block">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mb-6">
                  <i className="ri-store-2-line text-3xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  <strong>Vaciado de Locales</strong>
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-2">
                      <i className="ri-checkbox-circle-fill text-[#FF6B35]"></i>
                    </div>
                    <span>Tiendas, bares y restaurantes</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-2">
                      <i className="ri-checkbox-circle-fill text-[#FF6B35]"></i>
                    </div>
                    <span>Mobiliario y enseres completos</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-2">
                      <i className="ri-checkbox-circle-fill text-[#FF6B35]"></i>
                    </div>
                    <span>Limpieza final opcional</span>
                  </li>
                </ul>
              </Link>

              {/* Card 2 */}
              <Link to="/servicios" className="bg-white rounded-xl p-8 hover:-translate-y-2 transition-all duration-300 shadow-md hover:shadow-2xl cursor-pointer block">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mb-6">
                  <i className="ri-building-line text-3xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  <strong>Naves Industriales</strong>
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-2">
                      <i className="ri-checkbox-circle-fill text-[#FF6B35]"></i>
                    </div>
                    <span>Estanterías y palets</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-2">
                      <i className="ri-checkbox-circle-fill text-[#FF6B35]"></i>
                    </div>
                    <span>Maquinaria ligera no estructural</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-2">
                      <i className="ri-checkbox-circle-fill text-[#FF6B35]"></i>
                    </div>
                    <span>Grandes volúmenes</span>
                  </li>
                </ul>
              </Link>

              {/* Card 3 */}
              <Link to="/servicios" className="bg-white rounded-xl p-8 hover:-translate-y-2 transition-all duration-300 shadow-md hover:shadow-2xl cursor-pointer block">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mb-6">
                  <i className="ri-briefcase-line text-3xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  <strong>Oficinas Corporativas</strong>
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-2">
                      <i className="ri-checkbox-circle-fill text-[#FF6B35]"></i>
                    </div>
                    <span>Mobiliario de oficina completo</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-2">
                      <i className="ri-checkbox-circle-fill text-[#FF6B35]"></i>
                    </div>
                    <span>Archivos y documentación</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-2">
                      <i className="ri-checkbox-circle-fill text-[#FF6B35]"></i>
                    </div>
                    <span>Desmontaje de mamparas</span>
                  </li>
                </ul>
              </Link>
            </div>

            <div className="text-center mt-12">
              <Link
                to="/servicios"
                className="inline-flex items-center text-[#FF6B35] font-semibold hover:text-[#E55A2B] transition-colors cursor-pointer"
              >
                Ver todos los servicios
                <div className="w-5 h-5 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* Proceso en 5 Pasos */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="font-['Sora'] text-4xl font-bold text-gray-900 text-center mb-16">
              Cómo trabajamos
            </h2>

            <div className="relative">
              {/* Línea conectora - Desktop */}
              <div className="hidden lg:block absolute top-10 left-0 right-0 h-0.5 bg-gray-200" style={{ width: 'calc(100% - 160px)', left: '80px' }}></div>

              <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-4">
                {/* Paso 1 */}
                <div className="flex flex-col items-center text-center relative">
                  <div className="w-20 h-20 flex items-center justify-center bg-white border-3 border-[#FF6B35] rounded-full mb-4 relative z-10">
                    <span className="text-3xl font-bold text-[#FF6B35]">1</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Contacto</h3>
                  <p className="text-sm text-gray-600 max-w-[140px]">
                    Llámanos o escríbenos por WhatsApp para contarnos tu necesidad
                  </p>
                </div>

                {/* Paso 2 */}
                <div className="flex flex-col items-center text-center relative">
                  <div className="w-20 h-20 flex items-center justify-center bg-white border-3 border-[#FF6B35] rounded-full mb-4 relative z-10">
                    <span className="text-3xl font-bold text-[#FF6B35]">2</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Visita</h3>
                  <p className="text-sm text-gray-600 max-w-[140px]">
                    Visitamos el local o valoramos con fotos para presupuesto exacto
                  </p>
                </div>

                {/* Paso 3 */}
                <div className="flex flex-col items-center text-center relative">
                  <div className="w-20 h-20 flex items-center justify-center bg-white border-3 border-[#FF6B35] rounded-full mb-4 relative z-10">
                    <span className="text-3xl font-bold text-[#FF6B35]">3</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Coordinación</h3>
                  <p className="text-sm text-gray-600 max-w-[140px]">
                    Acordamos fecha, horario y detalles del servicio
                  </p>
                </div>

                {/* Paso 4 */}
                <div className="flex flex-col items-center text-center relative">
                  <div className="w-20 h-20 flex items-center justify-center bg-white border-3 border-[#FF6B35] rounded-full mb-4 relative z-10">
                    <span className="text-3xl font-bold text-[#FF6B35]">4</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Vaciado</h3>
                  <p className="text-sm text-gray-600 max-w-[140px]">
                    Realizamos el vaciado completo con gestión de residuos
                  </p>
                </div>

                {/* Paso 5 */}
                <div className="flex flex-col items-center text-center relative">
                  <div className="w-20 h-20 flex items-center justify-center bg-white border-3 border-[#FF6B35] rounded-full mb-4 relative z-10">
                    <span className="text-3xl font-bold text-[#FF6B35]">5</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Entrega</h3>
                  <p className="text-sm text-gray-600 max-w-[140px]">
                    Local vacío y limpio, listo para entrega o reforma
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Por Qué Contratar Nuestros Servicios */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="font-['Sora'] text-4xl font-bold text-gray-900 mb-6">
                  ¿Por qué contratar<br />nuestros servicios?
                </h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-shield-check-line text-2xl text-[#FF6B35]"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Seguro de Responsabilidad Civil
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        Cubiertos ante todo tipo de circunstancias. <Link to="/empresa" className="text-[#FF6B35] hover:underline">Nuestra empresa</Link> incluye en todos los presupuestos un nº de póliza. Puedes evitar sorpresas desagradables exigiendo a las empresas que incluyan este dato <strong>siempre por escrito</strong>.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-recycle-line text-2xl text-[#FF6B35]"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Reciclamos y Desechamos Adecuadamente
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        Evita multas e infracciones por dejar muebles y electrodomésticos tirados en la calle. Llevamos todos los muebles y enseres a sitios donde se les dará una segunda vida útil o se reciclarán sin generar residuos que pudieran afectar al medio ambiente. <Link to="/servicios" className="text-[#FF6B35] hover:underline">Conoce más sobre nuestros servicios</Link>.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-tools-line text-2xl text-[#FF6B35]"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Especialistas en Desmontajes
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        Contamos con todas las herramientas necesarias para <Link to="/servicios" className="text-[#FF6B35] hover:underline">desmontar y desalojar espacios</Link> de forma eficaz en el menor tiempo posible. Desmontamos todo tipo de muebles y dimensiones de manera profesional.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-service-line text-2xl text-[#FF6B35]"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Servicios Adicionales
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        Facilitamos servicios adicionales que sean necesarios como limpiezas de choque, rehabilitación, derribos o reformas. De este modo la coordinación para todas las tareas es mucho más eficiente que si se realiza cada labor con una empresa distinta. <Link to="/contacto" className="text-[#FF6B35] hover:underline">Contáctanos para más información</Link>.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src="https://vaciadolocales.com/wp-content/uploads/2022/03/operario-vaciado.jpg"
                    alt="Operario profesional de vaciado de locales"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Opiniones de Clientes */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="font-['Sora'] text-4xl font-bold text-gray-900 mb-4">
                Opiniones de nuestros clientes
              </h2>
              <p className="text-lg text-gray-600">
                Lo que dicen las empresas que han confiado en nosotros
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {/* Testimonio 1 */}
              <div className="bg-gray-50 rounded-xl p-8 relative">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-600 leading-relaxed mb-6">
                  Empresa seria y puntual. Cuidan al detalle el mobiliario y el material antes, durante y después del servicio. En el caso del vaciado de mi local, se han apresurado para poder garantizar la productividad de la tienda. Precios competitivos. 100% recomendables.
                </p>
                <div className="flex items-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mr-3">
                    <i className="ri-user-line text-xl text-[#FF6B35]"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">Paula R.</p>
                    <p className="text-sm text-gray-500">Comercio Barcelona</p>
                  </div>
                </div>
              </div>

              {/* Testimonio 2 */}
              <div className="bg-gray-50 rounded-xl p-8 relative">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-600 leading-relaxed mb-6">
                  Solicité un vaciado completo de nave industrial con todo tipo de contenido: enseres, muebles, electrodomésticos, máquinas, incluyendo desmontaje de muebles y cabeceros. El trabajo se realizó con precio cerrado previamente de forma impecable dejando además todo limpio y sin desperfectos.
                </p>
                <div className="flex items-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mr-3">
                    <i className="ri-user-line text-xl text-[#FF6B35]"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">Eulalia S.</p>
                    <p className="text-sm text-gray-500">Nave Industrial</p>
                  </div>
                </div>
              </div>

              {/* Testimonio 3 */}
              <div className="bg-gray-50 rounded-xl p-8 relative">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-600 leading-relaxed mb-6">
                  Son geniales... llegaron unos profesionales con ganas de trabajar. Aún siendo un local comercial grande, lo vaciaron de manera rápida y sin ningún tipo de desperfecto en el suelo ni en las paredes. Cuidan los detalles y el trato es amable.
                </p>
                <div className="flex items-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mr-3">
                    <i className="ri-user-line text-xl text-[#FF6B35]"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">Marta S.</p>
                    <p className="text-sm text-gray-500">Local Comercial</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Clientes - Trabajos Realizados */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="font-['Sora'] text-4xl font-bold text-gray-900 mb-4">
                Clientes - Trabajos realizados
              </h2>
              <p className="text-lg text-gray-600">
                Empresas que han confiado en nuestros servicios
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center">
              <div className="flex items-center justify-center p-6 bg-white rounded-xl">
                <img
                  src="https://vaciadolocales.com/wp-content/uploads/2022/02/el-corte-ingles-logo-gris.png"
                  alt="El Corte Inglés"
                  className="max-h-16 w-auto opacity-60 hover:opacity-100 transition-opacity"
                />
              </div>
              <div className="flex items-center justify-center p-6 bg-white rounded-xl">
                <img
                  src="https://vaciadolocales.com/wp-content/uploads/2022/02/regus-logo-gris-3.png"
                  alt="Regus"
                  className="max-h-16 w-auto opacity-60 hover:opacity-100 transition-opacity"
                />
              </div>
              <div className="flex items-center justify-center p-6 bg-white rounded-xl">
                <img
                  src="https://vaciadolocales.com/wp-content/uploads/2022/02/maremagnum-logo-gris.png"
                  alt="Maremagnum"
                  className="max-h-16 w-auto opacity-60 hover:opacity-100 transition-opacity"
                />
              </div>
              <div className="flex items-center justify-center p-6 bg-white rounded-xl">
                <img
                  src="https://vaciadolocales.com/wp-content/uploads/2022/02/splau-logo-gris.png"
                  alt="Splau"
                  className="max-h-16 w-auto opacity-60 hover:opacity-100 transition-opacity"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Zona de Servicio */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="font-['Sora'] text-4xl font-bold text-gray-900 mb-4">
                Zona de servicio
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Realizamos <strong>vaciado de locales comerciales</strong>, <strong>vaciado de naves industriales Barcelona</strong> y <strong>vaciado de oficinas</strong> en toda Barcelona y provincia. <Link to="/contacto" className="text-[#FF6B35] hover:underline font-semibold">Consulta nuestra zona de cobertura completa</Link>.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              {/* Barcelona Capital */}
              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-3">
                    <i className="ri-building-2-fill text-xl text-[#FF6B35]"></i>
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg">Barcelona Capital</h3>
                </div>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Ciutat Vella
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    <a href="https://es.wikipedia.org/wiki/Barcelona" target="_blank" rel="noopener noreferrer" className="text-[#FF6B35] hover:underline">Eixample</a>
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Sants-Montjuïc
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Les Corts
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Sarrià–Sant Gervasi
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Gràcia
                  </li>
                </ul>
              </div>

              {/* Área Metropolitana Sur */}
              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-3">
                    <i className="ri-community-fill text-xl text-[#FF6B35]"></i>
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg">Área Metropolitana Sur</h3>
                </div>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    L'Hospitalet de Llobregat
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Cornellà de Llobregat
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    El Prat de Llobregat
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Sant Boi de Llobregat
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Gavà
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Viladecans
                  </li>
                </ul>
              </div>

              {/* Área Metropolitana Norte */}
              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-3">
                    <i className="ri-home-smile-fill text-xl text-[#FF6B35]"></i>
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg">Área Metropolitana Norte</h3>
                </div>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Badalona
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Santa Coloma de Gramenet
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Sant Adrià de Besòs
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Montcada i Reixac
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Ripollet
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Cerdanyola del Vallès
                  </li>
                </ul>
              </div>

              {/* Provincia Barcelona */}
              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mr-3">
                    <i className="ri-road-map-fill text-xl text-[#FF6B35]"></i>
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg">Provincia Barcelona</h3>
                </div>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Terrassa
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Sabadell
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Mataró
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Granollers
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Sant Cugat del Vallès
                  </li>
                  <li className="flex items-center">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-map-pin-fill text-[#FF6B35] text-xs"></i>
                    </div>
                    Rubí
                  </li>
                </ul>
              </div>
            </div>

            {/* Mapa */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="font-['Sora'] text-2xl font-bold text-gray-900 mb-4">
                  Cobertura Completa en Barcelona
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  Nuestro equipo está estratégicamente ubicado en <strong>L'Hospitalet de Llobregat</strong>, lo que nos permite ofrecer un servicio rápido y eficiente en toda el área metropolitana de Barcelona y provincia. <Link to="/faq" className="text-[#FF6B35] hover:underline">Ver preguntas frecuentes</Link>.
                </p>
                <div className="flex items-start space-x-3 p-4 bg-orange-50 border-l-4 border-[#FF6B35] rounded-lg">
                  <div className="w-6 h-6 flex items-center justify-center mt-0.5">
                    <i className="ri-information-line text-xl text-[#FF6B35]"></i>
                  </div>
                  <p className="text-sm text-gray-700">
                    <strong>Importante:</strong> No recogemos un solo objeto suelto. Servicio mínimo: volumen equivalente a 1 furgoneta llena.
                  </p>
                </div>
              </div>
              <div>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2994.0234567890123!2d2.1098!3d41.3588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDIxJzMxLjciTiAywrAwNiczNS4zIkU!5e0!3m2!1ses!2ses!4v1234567890123!5m2!1ses!2ses"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Ubicación ECOSERVEIS en Barcelona"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mini FAQ */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="font-['Sora'] text-4xl font-bold text-gray-900 mb-4">
                Preguntas frecuentes
              </h2>
              <p className="text-lg text-gray-600">
                Resolvemos las dudas más comunes sobre nuestro servicio de vaciado
              </p>
            </div>

            <div className="space-y-4">
              <details className="group bg-gray-50 rounded-lg overflow-hidden">
                <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-100 transition-colors">
                  <h4 className="text-lg font-bold text-gray-900">
                    ¿En cuánto tiempo pueden realizar el vaciado?
                  </h4>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-add-line text-2xl text-[#FF6B35] group-open:hidden"></i>
                    <i className="ri-subtract-line text-2xl text-[#FF6B35] hidden group-open:block"></i>
                  </div>
                </summary>
                <div className="px-6 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    Según disponibilidad, podemos realizar el servicio en 24-48 horas. El tiempo exacto depende del volumen de material a retirar y la complejidad del trabajo. Contacta con nosotros para una valoración precisa de tu caso.
                  </p>
                </div>
              </details>

              <details className="group bg-gray-50 rounded-lg overflow-hidden">
                <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-100 transition-colors">
                  <h4 className="text-lg font-bold text-gray-900">
                    ¿Cómo se calcula el precio del servicio?
                  </h4>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-add-line text-2xl text-[#FF6B35] group-open:hidden"></i>
                    <i className="ri-subtract-line text-2xl text-[#FF6B35] hidden group-open:block"></i>
                  </div>
                </summary>
                <div className="px-6 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    El precio depende del volumen de material a retirar, el tipo de enseres, la accesibilidad del local, y si requiere desmontajes especiales. Ofrecemos presupuestos sin compromiso tras una visita o valoración fotográfica.
                  </p>
                </div>
              </details>

              <details className="group bg-gray-50 rounded-lg overflow-hidden">
                <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-100 transition-colors">
                  <h4 className="text-lg font-bold text-gray-900">
                    ¿Realizan desmontajes de mobiliario fijo?
                  </h4>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-add-line text-2xl text-[#FF6B35] group-open:hidden"></i>
                    <i className="ri-subtract-line text-2xl text-[#FF6B35] hidden group-open:block"></i>
                  </div>
                </summary>
                <div className="px-6 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    Sí, realizamos desmontajes no estructurales como estanterías, mostradores, mamparas de oficina, falsos techos accesibles, etc. No realizamos obras ni desmontajes que afecten a la estructura del edificio.
                  </p>
                </div>
              </details>
            </div>

            <div className="text-center mt-8">
              <Link
                to="/faq"
                className="inline-flex items-center text-[#FF6B35] font-semibold hover:text-[#E55A2B] transition-colors cursor-pointer"
              >
                Ver todas las preguntas frecuentes
                <div className="w-5 h-5 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="text-center lg:text-left">
                <h2 className="font-['Sora'] text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                  ¿Listo para<br />vaciar tu local?
                </h2>
                <p className="text-xl text-white/90 mb-8 leading-relaxed">
                  Servicio profesional en Barcelona y provincia.<br />
                  Presupuesto sin compromiso en 24-48h según disponibilidad.
                </p>
              </div>
              
              <div className="flex flex-col items-center lg:items-end space-y-6">
                <a
                  href="tel:+34644613451"
                  className="inline-flex items-center px-8 py-4 bg-white text-gray-900 text-lg font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-2xl whitespace-nowrap cursor-pointer group"
                >
                  <div className="w-6 h-6 flex items-center justify-center mr-3">
                    <i className="ri-phone-fill text-[#FF6B35]"></i>
                  </div>
                  Solicitar Presupuesto
                  <div className="w-8 h-8 flex items-center justify-center ml-3 bg-[#FF6B35] text-white rounded-full group-hover:bg-[#E55A2B] transition-colors">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </a>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-4 border border-white/20">
                  <div className="flex items-center space-x-4 text-white">
                    <div className="flex items-center">
                      <div className="w-5 h-5 flex items-center justify-center mr-2">
                        <i className="ri-shield-check-line text-[#FF6B35]"></i>
                      </div>
                      <span className="text-sm font-medium">Seguro incluido</span>
                    </div>
                    <div className="w-px h-4 bg-white/30"></div>
                    <div className="flex items-center">
                      <div className="w-5 h-5 flex items-center justify-center mr-2">
                        <i className="ri-time-line text-[#FF6B35]"></i>
                      </div>
                      <span className="text-sm font-medium">Servicio rápido</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default HomePage;